export default {
  comexstats: {
    menuItem: "Comex Stat (exportaciones)",
    pageTitle: "Comex Stat — Exportaciones Brasil",
    subtitle:
      "Compará exactamente dos años calendario: elegí ambos abajo y el país y NCM (clic en un resultado). En modo año calendario, el bloque mensual COMPARATIVO va después de las dos tablas por año.",
    countries: "Países",
    countriesMultiselectPlaceholder: "Buscar o elegir uno o más países",
    countriesMultiHint:
      "Uno o más países: buscá en el cuadro y tocá para agregar. Varios países = una sola petición combinada al MDIC.",
    countriesSelectAll: "Seleccionar todos",
    countriesRemoveAll: "Quitar todos",
    countriesEmptyMeansAll:
      "Sin país elegido — el informe consulta todos los países de la lista cargada (puede ser lento y devolver muchas tablas).",
    country: "País",
    countryPlaceholder: "Buscar país…",
    ncm: "Producto (NCM)",
    ncmPlaceholder: "Buscar NCM o descripción…",
    productLabel: "Nombre en la tabla",
    productLabelPlaceholder: "Opcional — por defecto la descripción del NCM",
    productLabelHint: "Texto de la columna PRODUCTO; vacío = descripción del NCM elegido.",
    years: "Años a comparar (solo dos)",
    yearSelectFirst: "Primer año",
    yearSelectSecond: "Segundo año",
    yearsHint: "Elegí dos años distintos. Solo se cargan y comparan esos dos.",
    yearsInvalid: "Elegí dos años distintos entre 1997 y el año en curso.",
    filtersIncomplete: "Elegí un país.",
    loadingCountriesList: "Cargando países…",
    noCountriesLoaded: "No se pudo cargar la lista (el ID guardado igual se usa si ejecutás).",
    countriesListError: "No se pudieron cargar los países desde Comex Stat.",
    countryIdFallback: "ID de país (si la búsqueda falla)",
    countryIdFallbackPlaceholder: "ej. 676",
    countryIdFallbackHint:
      "ID numérico de la tabla de países del MDIC. Útil si el autocompletado no responde.",
    applyCountryId: "Aplicar",
    ncmCodeFallback: "Código NCM (solo dígitos)",
    ncmCodeFallbackPlaceholder: "ej. 12024200",
    ncmCodeFallbackHint: "Agrega el código sin usar la búsqueda.",
    addNcmCode: "Agregar",
    countryIdInvalid: "Indicá un ID de país válido (número positivo).",
    ncmCodeInvalid: "Indicá un NCM de 4 a 8 dígitos.",
    hintNeedCountry: "Elegí un país de la lista.",
    hintNeedNcm: "Elegí al menos un NCM de la lista o agregá un código abajo.",
    hintNeedYears: "Elegí dos años distintos.",
    monthComparisonTitle: "COMPARATIVO — meses calendario",
    monthComparisonDeltaMt: "Δ MT destino (reciente − anterior)",
    monthComparisonDeltaShare: "COMPARATIVO",
    monthComparisonYoYDest: "YoY % MT destino",
    destinationMtExplain:
      "«MT destino (Comex)» es el peso neto exportado desde Brasil al país elegido para el NCM (Comex Stat del MDIC); no existe en la API un campo que se llame A-L TONS. Si en tu Excel la columna A-L TONS sale de contratos, carga manual u otro sistema, hay que rastrear esa fuente aparte; acá solo mostramos el tonelaje oficial Comex al destino.",
    msExplain:
      "MS es solo la columna de participación (%). Fórmula: MS = MT destino ÷ («AAAA - MT») × 100 — misma fila/mes: toneladas destino entre toneladas NCM mundiales.",
    yearBasis: "Definición de año",
    calendar: "Calendario (ene–dic)",
    cropMarch: "Año cosecha (mar–feb)",
    run: "Actualizar informe",
    loading: "Consultando Comex Stat…",
    error: "Error en la solicitud",
    noResults: "Sin filas para este filtro.",
    period: "PERIODO",
    product: "PRODUCTO",
    officialMt: "MT destino (Comex)",
    yearWorldMt: "{year} - MT",
    msGlobal: "MS",
    comparisonTitle: "COMPARATIVO",
    comparisonYear: "AÑO",
    totalShippedShort: "MT destino",
    annualShareShort: "MS",
    yoyChange: "CAMBIO",
    totalShippedFooter: "TOTAL SHIPPED {year}",
    generalStatsTitle: "ESTADÍSTICAS BRASIL — GENERAL",
    generalStatsSubtitle:
      "Exportaciones mundiales del NCM elegido (todos los destinos), mes a mes; misma serie que la columna «AAAA - MT» en la tabla por país. Un bloque por año cargado.",
    generalStatsCardTitle: "{year}",
    includeApiDebugLabel:
      "Al ejecutar con dos países, incluir abajo un bloque JSON de depuración (forma de la respuesta MDIC y conteos de filas) para copiar y pegar en soporte.",
    apiDebugCardTitle: "Depuración API (multi-país)",
    apiDebugCopy: "Copiar JSON",
    apiNote:
      "Los datos se cargan en tu navegador desde el API público del MDIC. Los meses calendario ya cerrados se guardan en la base de LawAI (por instancia/cliente) para no repetir esas consultas al MDIC. Tenés que estar logueado para leer/escribir la caché. Si falla, esperá unos segundos y pulsá Actualizar.",
    exportExcel: "Exportar a Excel",
    exportExcelDone: "Se descargó el archivo.",
    exportExcelError: "No se pudo generar el Excel.",
    exportExcelNoRows: "No hay filas de tablas para exportar.",
  },
};
